/**
 * The calendar every Cost Services "today" is read on: São Paulo, like the close-out journal date
 * (`costProvisionToday`). The API, the screens and MCP decide "ended", the default end date and
 * the base-type lock on the same day, so a link never reads as ended on one side and live on the
 * other around midnight UTC.
 */
export const COST_SERVICES_TIMEZONE = 'America/Sao_Paulo';

/** Today as `YYYY-MM-DD` in São Paulo. Example: 2026-10-10T01:30Z → "2026-10-09". */
export function costServicesToday(now: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: COST_SERVICES_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(now);
  const part = (type: string) => parts.find((item) => item.type === type)?.value ?? '';
  return `${part('year')}-${part('month')}-${part('day')}`;
}

/**
 * The `YYYY-MM-DD` of a date-only value (`@db.Date`, stored at midnight UTC) or of a UTC instant.
 * The one formatter the cost engine uses for competency, journal and period days.
 * Example: new Date('2026-10-31T00:00:00Z') → "2026-10-31".
 */
export function costDateOnly(date: Date): string {
  return date.toISOString().slice(0, 10);
}

/**
 * "Today" for cost RECOGNITION (the as-of month of the D22 plan poster, the expected-candidate
 * horizon, the FX rate day cap): the UTC day, exactly as the revenue side bounds what it may
 * recognise (`ContractRevenueRecognitionService.currentCompetencyCutoff` is the UTC month end).
 * The cost of a month follows its revenue, so both sides must call the same month "due". The
 * user-facing "today" (link windows, close-out date, aging) stays `costServicesToday` (São Paulo).
 * Example: 2026-10-31T23:30-03:00 (= 2026-11-01T02:30Z) → "2026-11-01", as revenue reads it.
 */
export function costRecognitionToday(now: Date = new Date()): string {
  return costDateOnly(now);
}
